import { Controller } from "@hotwired/stimulus"
import {enter, leave} from "tailwindcss-stimulus-components/src/transition"


// Connects to data-controller="transition"
export default class extends Controller {
  static targets = ["child"]
  static values = {
      autoTransition: { type: Boolean, default: true },
      open: Boolean,
  }

  connect() {
    if (this.autoTransitionValue) {
        this.enter()
    }
  }

  enter() {
   return Promise
       .all(this.childTargets.map(child => enter(child)))
       .then(promises => {
           this.openValue = true
           return promises
       })
  }

  leave() {
    return Promise
        .all(this.childTargets.map(child => leave(child)))
        .then(promises => {
            this.openValue = false
            return promises
        })

  }

  toggle() {
    if (this.openValue) {
        this.leave()
    } else {
        this.enter()
    }
  }

  remove() {
      this.leave()
          .then(() => {
              this.element.remove()
          })
  }
}
